import { Typography } from "@mui/material"


export default function AdminUserDashboard() {

    return(<div className='image-background-1'>
          <div className='dark-alpha-85'>
        
       <div style={{minHeight:'600px', margin:'auto', width:'1000px', textAlign:'center'}}><img src='/Instagate.png' style={{width:'500px', margin:'auto', marginTop:'50px', marginBottom:'200px', marginLeft:'75px'}}></img></div>
        </div>
        </div>)
}